import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../style/theme';
import Arrow from './ArrowSVG/index';
import Whatsapp from '../Img/SocialIconsSVG/Whatsapp';

const ButtonStyles = styled.button`
  display: flex;
  justify-content: center;
  cursor: pointer;
  background-color: black;
  ${props => props.isVisible && css`
    background-color: ${theme.colors.primary};
  `}
  border: none;
  border-radius: .2em;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px;
  text-decoration: none;
  padding: .3em .7em;
  color: #fff;
  transition: ${theme.transitions.default} opacity;
  :hover {
    opacity: 0.8;
  }
  :focus {
    outline: none;
  }
  > svg {
    display: flex;
    align-self: center;
    padding: 0;
    width: 20px;
    margin-left: .5rem;
    @media (max-width: 380px) {
      width: 30px;
      margin-right: 1rem;
    }
  }
  width: 100%;
  ${props => (props.textButton === 'Enviar') && css`
    width: 100px;
  `}
  height: 100%;
`;

const WhatsappStyles = styled.a`
  display: flex;
  justify-content: center;
  cursor: pointer;
  background-color: black;
  ${props => props.isVisible && css`
    background-color: ${theme.colors.primary};
  `}
  border: none;
  border-radius: .2em;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 2px;
  text-decoration: none;
  padding: .3em .7em;
  color: #fff;
  transition: ${theme.transitions.default} opacity;
  :hover {
    opacity: 0.8;
  }
  :focus {
    outline: none;
  }
  > svg {
    display: flex;
    align-self: center;
    padding: 0;
    width: 20px;
    margin-left: .5rem;
    @media (max-width: 380px) {
      width: 30px;
      margin-right: 1rem;
    }
  }
  width: 100%;
  ${props => (props.textButton === 'Enviar') && css`
    width: 100px;
  `}
  height: 100%;
`;

const ArrowLink = styled.button`
  display: flex;
  align-items: center;
  max-width: 60px;
  flex: 1 0 100px;
  background-color: Transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline:none;
  > svg {
    padding: 0;
    width: 1.5rem;
  }
`;

const Button = (props) => {
  if (props.buttonType === 'Close') {
    return (
      <ArrowLink onClick={props.onClick}>
        <Arrow fill="#6BB951" />
      </ArrowLink>
    );
  }
  if (props.buttonType === 'Whatsapp') {
    return (
      <WhatsappStyles
        buttonType={props.buttonType}
        isVisible={props.isVisible}
        textButton={props.textButton}
        href={props.link}
        target="_blank"
      >
        <span>
          {props.textButton}
        </span>
        <Whatsapp color="#fff" origin="botton form" />
      </WhatsappStyles>
    );
  }
  return (
    <ButtonStyles
      buttonType={props.buttonType}
      onClick={props.onClick}
      isVisible={props.isVisible}
      textButton={props.textButton}
    >
      {props.textButton}
    </ButtonStyles>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/UI/Buttons/index.jsx